<mat-nav-list>
  <ul class="side-nav__list">
    <li class="side-nav__item">
      <a mat-list-item
         class="side-nav__link"
         routerLink="/home"
         routerLinkActive="active">
        <mat-icon mat-list-icon class="side-nav__icon" role="img" aria-hidden="true" matTooltip="Forms" matTooltipPosition="above">home</mat-icon>
        <span matLine>Home</span>
      </a>
    </li>
    <li class="side-nav__item">
      <a mat-list-item
         class="side-nav__link"
         routerLink="/forms"
         routerLinkActive="active">
        <mat-icon mat-list-icon class="side-nav__icon" role="img" aria-hidden="true" matTooltip="Forms" matTooltipPosition="above">view_list</mat-icon>
        <span matLine>Forms</span>
      </a>
    </li>
    <li class="side-nav__item">
      <a mat-list-item
         class="side-nav__link"
         routerLinkActive="active"
         routerLink="/question-groups">
        <mat-icon mat-list-icon class="side-nav__icon" role="img" aria-hidden="true" matTooltip="Questions" matTooltipPosition="above">quiz</mat-icon>
        <span matLine>Questions</span>
      </a>
    </li>
    <li class="side-nav__item">
      <a mat-list-item
         class="side-nav__link"
         routerLinkActive="active"
         routerLink="/email">
        <mat-icon mat-list-icon class="side-nav__icon" role="img" aria-hidden="true" matTooltip="Email Templates" matTooltipPosition="above">email</mat-icon>
        <span matLine>Email Templates</span>
      </a>
    </li>
    <li class="side-nav__item">
      <a mat-list-item
         class="side-nav__link"
         routerLinkActive="active"
         routerLink="/letter">
        <mat-icon mat-list-icon class="side-nav__icon" role="img" aria-hidden="true" matTooltip="Letter Templates" matTooltipPosition="above">mail_outline</mat-icon>
        <span matLine>Letter Templates</span>
      </a>
    </li>
    <li class="side-nav__item">
      <a mat-list-item
         class="side-nav__link"
         routerLinkActive="active"
         routerLink="/text">
        <mat-icon mat-list-icon class="side-nav__icon" role="img" aria-hidden="true" matTooltip="Text Message Templates" matTooltipPosition="above">textsms</mat-icon>
        <span matLine>Text Message Templates</span>
      </a>
    </li>
  </ul>
</mat-nav-list>
